theme.headerSticky = (function () {
  function ScrollSticky() {
    const headerStickyWrapper = document.querySelector(".header__area");
    const headerStickyTarget = document.querySelector(".header__sticky");
    const stickyScrollingText = document.querySelector(
      '[data-sticky-scrolling-text="true"]'
    );
    const scrollingTextSection = stickyScrollingText
      ? stickyScrollingText.closest(".shopify-section")
      : null;

    let scrollingTextPlaceholder = null;
    let isSticky = false;

    let cachedThreshold = null;


    const setScrollingTextHeightVar = (height = 0) => {
      document.documentElement.style.setProperty(
        "--scrolling-text-sticky-height",
        `${height}px`
      );
    };

    const ensureScrollingTextPlaceholder = (height) => {
      if (!scrollingTextSection) return;

      if (!scrollingTextPlaceholder) {
        scrollingTextPlaceholder = document.querySelector(
          ".scrolling-text-sticky-placeholder"
        );
      }

      if (!scrollingTextPlaceholder) {
        scrollingTextPlaceholder = document.createElement("div");
        scrollingTextPlaceholder.className =
          "scrolling-text-sticky-placeholder";
        scrollingTextSection.parentNode.insertBefore(
          scrollingTextPlaceholder,
          scrollingTextSection.nextSibling
        );
      }

      scrollingTextPlaceholder.style.height = `${height}px`;
    };

    const removeScrollingTextPlaceholder = () => {
      scrollingTextPlaceholder?.remove();
      scrollingTextPlaceholder = null;
      document.querySelector(".scrolling-text-sticky-placeholder")?.remove();
    };

    const activateSticky = () => {
      if (isSticky) return;
      isSticky = true;

      const scrollingTextHeight = scrollingTextSection
        ? scrollingTextSection.offsetHeight
        : 0;
      const headerHeight = headerStickyTarget
        ? headerStickyTarget.offsetHeight
        : 0;

      setScrollingTextHeightVar(scrollingTextHeight);

      if (scrollingTextSection) {
        ensureScrollingTextPlaceholder(scrollingTextHeight);
        scrollingTextSection.classList.add("scrolling-text--sticky-active");
      }

      if (headerStickyTarget && headerStickyWrapper) {
        headerStickyWrapper.style.height = `${headerHeight}px`;
        headerStickyTarget.classList.add("sticky");
      }
    };

    const deactivateSticky = () => {
      if (!isSticky) return;
      isSticky = false;

      if (headerStickyTarget && headerStickyWrapper) {
        headerStickyTarget.classList.remove("sticky");
        headerStickyWrapper.style.height = "";
      }

      if (scrollingTextSection) {
        scrollingTextSection.classList.remove("scrolling-text--sticky-active");
        removeScrollingTextPlaceholder();
      }

      setScrollingTextHeightVar(0);
    };

    const getStickyThreshold = () => {
       if (scrollingTextSection) {
      cachedThreshold = TopOffset(scrollingTextSection).top;
      } else {
        cachedThreshold = headerStickyWrapper
          ? headerStickyWrapper.clientHeight
          : 0;
      }
    };

    setScrollingTextHeightVar(0);

    getStickyThreshold();

    window.addEventListener("resize", function () {
      getStickyThreshold();
      if (!isSticky) return;

      if (scrollingTextSection) {
        const scrollingTextHeight = scrollingTextSection.offsetHeight;
        ensureScrollingTextPlaceholder(scrollingTextHeight);
        setScrollingTextHeightVar(scrollingTextHeight);
      }

      if (headerStickyTarget && headerStickyWrapper) {
        headerStickyWrapper.style.height = `${headerStickyTarget.offsetHeight}px`;
      }
    });

    if (headerStickyTarget || scrollingTextSection) {
      window.addEventListener("scroll", function () {
        if (window.scrollY > cachedThreshold) {
          activateSticky();
        } else {
          deactivateSticky();
        }
      });
    }
  }
  return ScrollSticky;
})();
